import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react.js';

export const IntencaoRegistroPrecoItens = ({ itens }) => {
  const renderItem = item => (
    <TableActions key={item.get('id')} data={item} renderButtons={false}>
      <td>{item.get('lote')}</td>
      <td>{item.get('ordem')}</td>
      <td>{item.get('descricao')}</td>
      <td className="right">
        <NumberFormatter value={item.get('quantidade')} format="0,0.0000" />
      </td>
      <td>{item.get('unidade')}</td>
      <td className="right">
        <NumberFormatter value={item.get('valorUnitario')} format="0,0.0000" />
      </td>
      <td className="right">
        <NumberFormatter value={item.get('valorTotal')} format="0,0.0000" />
      </td>
    </TableActions>
  );

  return (
    <div className="panel-table-outer">
      <table className="panel-table striped fancy">
        <TableHeader empty={itens.isEmpty()} text="Não há itens para esta IRP.">
          <tr>
            <th>Lote</th>
            <th>Ordem</th>
            <th>Descrição</th>
            <th className="right">Quantidade</th>
            <th>Unidade</th>
            <th className="right">Valor Unitário</th>
            <th className="right">Valor Total</th>
          </tr>
        </TableHeader>
        <tbody>{itens.map(renderItem)}</tbody>
      </table>
    </div>
  );
};

IntencaoRegistroPrecoItens.propTypes = {
  itens: PropTypes.object.isRequired
};

export default IntencaoRegistroPrecoItens;
